import { TOOLKIT, PRINCIPLES, BENEFITS } from "@/data/portfolio";
import Benefit from "@/components/site/Benefit";
import { T, useLang } from "@/lib/i18n";


function Chip({ children, testid }) {
  return (
    <li
      data-testid={testid}
      className="text-[13px] px-3.5 py-1.5 rounded-full border border-[#e5e0d8] bg-white text-[#14352a] hover:border-[#9a7218] hover:text-[#9a7218] transition-colors"
    >
      {children}
    </li>
  );
}

export default function Toolkit() {
  const { t } = useLang();
  return (
    <section
      id="toolkit"
      data-testid="toolkit-section"
      className="border-t border-[#e5e0d8] section-pad bg-[#f2ece4]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">
        <div className="max-w-2xl">
          <div className="font-mono-label text-[11px] text-[#9a7218]">{t("07 · My tool kit")}</div>
        </div>

        <div className="mt-8 grid md:grid-cols-2 gap-x-10 gap-y-7">
          {TOOLKIT.map((g, i) => (
            <div key={g.group} data-testid={`toolkit-group-${i}`}>
              <div className="font-mono-label text-[10px] text-[#55625b]">{t(g.group)}</div>
              <ul className="mt-3 flex flex-wrap gap-2">
                {g.items.map((it) => (
                  <Chip key={it} testid={`toolkit-chip-${it.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                    {it}
                  </Chip>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-[#d4cebe]">
          <ol data-testid="working-principles" className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="sm:col-span-2 lg:col-span-4 font-mono-label text-[10px] text-[#55625b]">{t("Working principles")}</div>
            {PRINCIPLES.map((p, i) => (
              <li
                key={p.title}
                data-testid={`principle-${i}`}
                className="grid grid-cols-[2rem_1fr] gap-2 border-t border-[#e5e0d8] pt-3"
              >
                <span className="font-mono-label text-[9px] text-[#9a7218] pt-1.5">0{i + 1}</span>
                <div>
                  <div className="font-display text-lg text-[#14352a] leading-snug">{t(p.title)}</div>
                  <p className="text-sm text-[#55625b]">{t(p.body)}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <Benefit text={BENEFITS.toolkit} testid="benefit-toolkit" />
      </div>
    </section>
  );
}
